import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import Cropper from "cropperjs";

/**
 * Composant du cropper image
 * @implements OnInit
 */
@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit {
    private largeurMax: number = 800;
    private hauteurMax: number = 600;

    private cropper: Cropper;
    public imageDestination: string = '';
    
    @ViewChild("image", { static: false }) imageElement: ElementRef;
    @Input("src") imageSource: string;
    @Input() autoCrop: boolean;

    /**
     * Apr�s l'initialisation de la vue
     */
    public ngAfterViewInit() {
        this.initCropper();
    }

    /**
     * Initialisation du composant
     */
    public ngOnInit() { }

    /**
     * Effectuer un zoom
     * @param ratio
     */
    public zoomTo(ratio) {
        this.cropper.zoomTo(ratio);
    }

    /**
     * Effectuer un zoom
     * @param ratio
     */
    public zoom(ratio) {
        this.cropper.zoom(ratio);
    }

    /**
     * Effectuer une rotation
     * @param ratio
     */
    public rotateTo(ratio) {
        this.cropper.rotateTo(ratio);
    }

    /**
     * Effectuer une rotation
     * @param ratio
     */
    public rotate(ratio) {
        this.cropper.rotate(ratio);
    }

    /**
     * Activer le mode d�placement
     */
    public enableDragModeMove() {
        this.cropper.setDragMode('move');
    }

    /**
     * Activer le mode crop
     */
    public enableDragModeCrop() {
        this.cropper.setDragMode('crop');
    }

    /**
     * Effectuer un crop de l'image
     */
    public crop(callback = (result: string) => { }) {
        this.imageDestination = null;
        const canvas = this.cropper.getCroppedCanvas();
        const resultCrop = canvas.toDataURL();

        const ctx = canvas.getContext("2d");
        const img = new Image;
        img.onload = () => {
            var iw = img.width;
            var ih = img.height;
            var iwScaled = iw;
            var ihScaled = ih;
            if (iw > this.largeurMax || ih > this.hauteurMax) {
                var scale = Math.min((this.largeurMax / iw), (this.hauteurMax / ih));
                iwScaled *= scale;
                ihScaled *= scale;
            }
            canvas.width = iwScaled;
            canvas.height = ihScaled;
            ctx.drawImage(img, 0, 0, iwScaled, ihScaled);

            const resultResize = canvas.toDataURL();
            this.imageDestination = resultResize;
            callback(this.imageDestination);
        }
        img.src = resultCrop;
    }

    /**
     * Initialisation du cropper
     */
    private initCropper() {
        var opt: Cropper.Options = {
            zoomable: true,
            rotatable: true,
            movable: true,
            scalable: true,
            dragMode: 'crop',
            cropBoxMovable: false,
            cropBoxResizable: true,
            center: false,
            zoomOnWheel: false,
            zoomOnTouch: false,
            autoCrop: true,
            autoCropArea: 1,
            guides: false,
            background: false,
            checkCrossOrigin: false,
            aspectRatio: NaN
        };
        if (this.autoCrop) {
            opt.crop = () => {
                this.crop();
            }
        }
        this.cropper = new Cropper(this.imageElement.nativeElement, opt);
    }
}
